export const delay = async (milliseconds: number): Promise<void> => await new Promise((resolve) => setTimeout(resolve, milliseconds))